import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Element } from 'react-scroll';
import LiveCarouselSection from 'screens/Live/components/LiveCarouselSection';
import { COLLECTION_THUMBNAIL_IMAGE, renderImage } from 'helpers/ImageHelper';
import Divider from 'components/Divider';
import useSearchResults from './hooks/useSearchResults';
import Style from './SearchResults.module.scss';

const { epg_backToScheduleButton } = window.Language;

const SearchResults = ({
  accessToken,
  breakpoint,
  favoritesManager,
  onClearSearch,
  panelCount,
  setPanelCount = () => {},
  searchCompleted,
  setSearchCompleted,
  searchInput,
  setCurrentVideo,
}) => {
  const getNoResultText = searchInput => `D’oh! ${searchInput} isn’t live now. Try again?`;
  const { panels } = useSelector(state => state.live);

  const { sortedLivePanels, sortedUpcomingPanels, shouldRender } = useSearchResults({
    panels,
    searchInput,
    setPanelCount,
  });
  const imageRender = image =>
    renderImage({
      breakpoint,
      imageType: COLLECTION_THUMBNAIL_IMAGE,
      ...image,
    });

  const epgCarouselProps = {
    accessToken,
    panel: panels,
    renderImage: imageRender,
    breakpoint,
    favoritesManager,
    panelCount,
    searchCompleted,
    setSearchCompleted,
    searchTerm: searchInput,
  };

  if (shouldRender) {
    return (
      <Element name="searchResults" className={Style.resultsContainer}>
        <Divider Style={Style} />
        {sortedLivePanels.length > 0 && (
          <LiveCarouselSection
            dropdownHeadline="Live Now"
            epgItems={sortedLivePanels}
            Style={Style}
            {...epgCarouselProps}
          />
        )}

        {sortedUpcomingPanels.length > 0 && (
          <LiveCarouselSection
            dropdownHeadline="Upcoming"
            epgItems={sortedUpcomingPanels}
            Style={Style}
            selectModalVideo={setCurrentVideo}
            {...epgCarouselProps}
          />
        )}
      </Element>
    );
  }
  return (
    <Element name="searchResults">
      <div className={Style.resultsContainer}>
        <Divider Style={Style} />
        <div className={Style.noResultsContainer}>
          <span className={Style.noResultsText}>{getNoResultText(searchInput)}</span>
          <button className={Style.returnToScheduleBtn} onClick={onClearSearch}>
            {epg_backToScheduleButton}
          </button>
        </div>
        <Divider Style={Style} />
      </div>
    </Element>
  );
};

SearchResults.defaultProps = {
  panels: {},
};

SearchResults.propTypes = {
  accessToken: PropTypes.string,
  breakpoint: PropTypes.string,
  epgStyle: PropTypes.string,
  favoritesManager: PropTypes.shape({}),
  onClearSearch: PropTypes.func,
  panelCount: PropTypes.number,
  panels: PropTypes.shape({}),
  searchCompleted: PropTypes.bool,
  setSearchCompleted: PropTypes.func,
  searchInput: PropTypes.string,
  setCurrentVideo: PropTypes.func,
  setPanelCount: PropTypes.func,
};

export default SearchResults;
